import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { TranslationHelpers } from '../../../i18n/translationHelpers';
import { destroyTooltip, setTooltip } from '../../../utils/rexTooltip';
import '../../../../src/rex.css';
import 'tippy.js/dist/tippy.css';
import { Instance } from 'tippy.js';

interface IInfoTooltipProps {
    id: string;
    tooltipText: FormattedMessage.MessageDescriptor | string;
    touchSize?: [number, number];
    uniqueId: string;
}

export const InfoTooltipWrapper = styled.div<Pick<IInfoTooltipProps, 'touchSize'>>`
    height: ${(props) => (props.touchSize ? props.touchSize[1] + 'px' : '16px')};
    position: absolute;
    right: 0;
    top: 0;
    display: flex;
`;

export const InfoTooltip = ({ tooltipText, touchSize, uniqueId }: IInfoTooltipProps) => {
    const text = TranslationHelpers.isMessageDescriptor(tooltipText)
        ? TranslationHelpers.getFormattedMessage(tooltipText.id)
        : tooltipText;

    const buttonRef = useRef<HTMLButtonElement>(null);
    const tooltipInstanceRef = useRef<Instance | null>(null);

    useEffect(() => {
        if (buttonRef.current) {
            tooltipInstanceRef.current = setTooltip(buttonRef.current);
        }

        return () => {
            if (tooltipInstanceRef.current) {
                destroyTooltip(tooltipInstanceRef.current);
                tooltipInstanceRef.current = null;
            }
        };
    }, [text]); // reconstruct the tooltip when the text changes

    return (
        <div>
            <InfoTooltipWrapper touchSize={touchSize}>
                <button
                    id="trigger"
                    aria-haspopup="true"
                    aria-labelledby="trigger_t"
                    data-template={`trigger_t${uniqueId}`}
                    ref={buttonRef}
                >
                    <span aria-hidden="true" className="rex-icon-info-outlined"></span>
                </button>
                <div style={{ display: 'none' }}>
                    <div id={`trigger_t${uniqueId}`}>{text}</div>
                </div>
            </InfoTooltipWrapper>
        </div>
    );
};
